import React from 'react';
import { MailIcon, InstagramIcon, MessagesSquareIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-white/5 bg-ink-950 px-5 py-12" data-id="element-81" data-mp="3ggapns7ja73v">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center gap-6 text-center" data-id="element-82" data-mp="32oe11y52qfc8">
        <div data-id="element-83" data-mp="36oxyz3xh1mzf">
          <span className="font-display text-base font-bold tracking-tight text-white" data-id="element-84" data-mp="36oo5359b2vog">
            Capital Consciente
          </span>
          <p className="mt-2 max-w-md text-sm text-gray-500" data-id="element-85" data-mp="3uftlblj5rpza">
            El camino de una mentoría privada, sin la barrera de entrada.
          </p>
        </div>

        <div className="flex items-center gap-3" data-id="element-86" data-mp="3ldalzbekzvhs">
          <a href="mailto:hola@capitalconsciente.com" aria-label="Enviar un mail" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-87" data-mp="3lgooqkr5q6pr">
            <MailIcon className="h-4 w-4" data-id="element-88" data-mp="2evxb71f3hj2d" />
          </a>
          <a href="#" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-89" data-mp="3labrlvxno6qd">
            <InstagramIcon className="h-4 w-4" data-id="element-90" data-mp="3q83u1jvxfb8t" />
          </a>
          <a href="#" aria-label="Discord" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-91" data-mp="3qaq0fg72zkpg">
            <MessagesSquareIcon className="h-4 w-4" data-id="element-92" data-mp="hrifzooftryu" />
          </a>
        </div>

        <p className="text-xs text-gray-600" data-id="element-93" data-mp="ctgyh86nu0ph">
          © {new Date().getFullYear()} Capital Consciente. Este material es
          educativo y no constituye asesoramiento financiero.
        </p>
      </div>
    </footer>;
}